import type { IdToken } from '@auth0/auth0-react'

const CLOCK_SKEW_THRESHOLD_MS = 5 * 60 * 1000

export interface ClockSkewInfo {
  skewMinutes: number
  isAhead: boolean
}

export const detectClockSkew = (idToken?: IdToken | null): ClockSkewInfo | null => {
  if (!idToken?.iat) return null

  const skewMs = Date.now() - idToken.iat * 1000
  const absSkewMs = Math.abs(skewMs)

  if (absSkewMs <= CLOCK_SKEW_THRESHOLD_MS) return null

  return {
    skewMinutes: Math.round(absSkewMs / 60000),
    isAhead: skewMs > 0,
  }
}
